import {
  ConstrainedObject,
  ConstraintItemType,
  ConstraintModifierRepeater,
  ConstraintModifierRepeaterField,
  ConstraintScope,
  ConstraintType,
  SelectedElement,
} from '@Models';
import { selectedElementByScope } from '@Selectors/builder/myArmyList/common/constraints/elements/selectable/selected-element-by-scope';

const compareValue = (
  repeater: ConstraintModifierRepeater,
  value: number,
): number => {
  if (repeater.roundUp)
    return Math.ceil(value / (parseFloat(repeater.value) || 1));

  return Math.floor(value / (parseFloat(repeater.value) || 1));
};

export const howManyRepeat = (
  repeater: ConstraintModifierRepeater,
  constrainedObjects: ConstrainedObject[],
  selectedElements: SelectedElement[],
  selectedElement: SelectedElement,
): number => {
  if (repeater.field === ConstraintModifierRepeaterField.Selections) {
    const elements = selectedElementByScope(
      constrainedObjects,
      selectedElements,
      selectedElement,
      repeater.scope,
    );

    const elementCount = elements
      .filter(
        (element) =>
          repeater.childId === element.constrained.id &&
          repeater.childType === element.constrained.type,
      )
      .map((element) => element.count)
      .reduce((acc, count) => acc + count, 0);

    return compareValue(repeater, elementCount);
  } else if (repeater.field === ConstraintModifierRepeaterField.Point) {
    if (
      repeater.scope === ConstraintScope.Roster ||
      repeater.scope === ConstraintScope.Force
    ) {
      const element = constrainedObjects.find(
        (element) => element.type === ConstraintItemType.Roster,
      );
      const constraint = element?.constraints.find(
        (constraint) =>
          constraint.scope === repeater.scope &&
          constraint.type === ConstraintType.Max,
      );

      return compareValue(repeater, constraint?.value || 1);
    } else if (repeater.scope === ConstraintScope.Parent) {
      return compareValue(repeater, selectedElement.points);
    }
  }

  return 0;
};
